import { usePricingStore } from '../stores';
import { IPricingModal } from '../types';
import { useCallback } from 'react';

export interface IPricingModalMonitorResult {
  modalType: IPricingModal;
  isOpenModal: boolean;
  onCloseModal: () => void;
  onOpenModalCancelPlan: () => void;
  onOpenModalUninstall: () => void;
  onOpenModalDowngradePlan: () => void;
  onOpenModalReviewPlan: () => void;
  onOpenModalPricing: () => void;
}

export const usePricingModalMonitor = (): IPricingModalMonitorResult => {
  const modalType = usePricingStore((state) => state.openModal);
  const setOpenModal = usePricingStore((state) => state.setOpenModal);

  const isOpenModal = modalType !== IPricingModal.NONE;

  const onCloseModal = useCallback(() => {
    setOpenModal(IPricingModal.NONE);
  }, [setOpenModal]);

  const onOpenModalCancelPlan = () => {
    setOpenModal(IPricingModal.CANCEL_PLAN);
  };

  const onOpenModalUninstall = () => {
    setOpenModal(IPricingModal.UNINSTALL);
  };

  const onOpenModalDowngradePlan = () => {
    setOpenModal(IPricingModal.DOWNGRADE_PLAN);
  };

  const onOpenModalReviewPlan = () => {
    setOpenModal(IPricingModal.REVIEW_PLAN);
  };

  const onOpenModalPricing = () => {
    setOpenModal(IPricingModal.PRICING);
  };

  return {
    modalType,
    isOpenModal,
    onOpenModalCancelPlan,
    onCloseModal,
    onOpenModalDowngradePlan,
    onOpenModalReviewPlan,
    onOpenModalPricing,
    onOpenModalUninstall,
  };
};
